import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';

const ProtectedRoute = ({ children }) => {
  const authenticated = isAuthenticated();
  
  if (!authenticated) {
    // Redirect to login page if not authenticated
    return <Navigate to="/auth/login" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
